import { render, staticRenderFns } from "./ClassyIntegration.vue?vue&type=template&id=4e8438bc"
import script from "./ClassyIntegration.vue?vue&type=script&lang=js"
export * from "./ClassyIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports